<div class="total-container">
  <router-outlet></router-outlet>
</div>
